/** 商品×チャネル広告費ヒートマップの1セル。design README §4「rgba(47,122,110,α)・α>.45で白字」。 */
export function heatCellStyle(value: number, max: number): { background: string; color: string } {
  const alpha = max > 0 ? Math.min(0.85, (value / max) * 0.85) : 0;
  return { background: `rgba(47,122,110,${alpha.toFixed(3)})`, color: alpha > 0.45 ? "#ffffff" : "#1f2523" };
}

export function HeatCell({ value, max, text }: { value: number; max: number; text: string }) {
  const style = heatCellStyle(value, max);
  return (
    <span className="pl-heat-cell" style={style}>
      {text}
    </span>
  );
}
